import { type GroupChannel } from "@sendbird/chat/groupChannel";
import { type CoreMessageType, type SendableMessageType } from "@sendbird/uikit-react/types/utils";
import { Button } from "@src/appV2/redesign/components/Button";
import { MY_SHIFTS_FULL_PATH } from "@src/appV2/redesign/WorkerShifts/path";
import type React from "react";
import { useHistory } from "react-router-dom";

import {
  type ChatMessageWithText,
  isChatMessageWithText,
  isSendBirdGroupChannel,
  type PlacementChatMetadata,
} from "../types";
import { PlacementChatMessageLayout } from "./PlacementChatMessageLayout";

function PlacementChatInterviewScheduledMessageContent({
  chatMessage,
  chatChannel,
}: {
  chatMessage: ChatMessageWithText;
  chatChannel: GroupChannel;
}) {
  const { placementId } = chatChannel.cachedMetaData as PlacementChatMetadata;
  const history = useHistory();

  if (!chatMessage.message || !placementId) {
    return undefined as unknown as React.ReactElement;
  }

  const button = (
    <Button
      variant="contained"
      size="small"
      sx={{ mt: 4 }}
      onClick={() => {
        history.push(MY_SHIFTS_FULL_PATH);
      }}
    >
      View Bookings
    </Button>
  );

  return (
    <PlacementChatMessageLayout message={chatMessage.message.trim()} button={button} />
  ) as unknown as React.ReactElement;
}

export function PlacementChatInterviewScheduledMessage({
  message,
  channel,
}: {
  message: CoreMessageType;
  channel: unknown;
}) {
  const chatMessage = (
    typeof message === "object" && message !== null
      ? message
      : // FIXME: Automatically disabled during ESLint config update
        JSON.parse(JSON.stringify(message))
  ) as unknown;

  const chatChannel = (
    typeof channel === "object" && channel !== null
      ? channel
      : // FIXME: Automatically disabled during ESLint config update
        JSON.parse(JSON.stringify(channel))
  ) as unknown;

  if (!isChatMessageWithText(chatMessage) || !isSendBirdGroupChannel(chatChannel)) {
    return null as unknown as React.ReactElement;
  }

  if (
    chatMessage.customType === "PLACEMENT_APPLICATION_CHAT_INTERVIEW_SCHEDULED" &&
    chatChannel.customType === "placements"
  ) {
    return (
      <PlacementChatInterviewScheduledMessageContent
        chatMessage={chatMessage}
        chatChannel={chatChannel}
      />
    );
  }

  // the message user could be the managing (parent) facility, but this would be confusing for users
  // so we overwrite the name to show the true facility name
  const placementChatMetadata = chatChannel.cachedMetaData as PlacementChatMetadata;
  const { sender } = message as SendableMessageType;
  if (sender && placementChatMetadata.facilityName) {
    sender.nickname = placementChatMetadata.facilityName;
    sender.friendName = placementChatMetadata.facilityName;
  }

  return null as unknown as React.ReactElement;
}
